import { render, staticRenderFns } from "./GridAddWarningModal.vue?vue&type=template&id=2d4a1c51"
import script from "./GridAddWarningModal.vue?vue&type=script&lang=js"
export * from "./GridAddWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports